import React from "react";
import OfferCard from "./offerCard";
import { useLoyalty } from "../../hooks/";
import { format } from "date-fns";

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

const OfferCards = ({ offers, setData, history, setModal, cardMargin }) => {
  const { movieManiaStatus, checkMovieManiaStatus, setSelectedEvent } =
    useLoyalty();

  return (
    <>
      {offers.map((offer, index) => {
        let lock = offer?.active === false;
        let modalTitle = null;
        let modalMessage = `The 
                        ${capitalizeFirstLetter(offer?.offerName || "")} 
                        ${offer?.lockMessage}
                        `;
        let lockMessage = capitalizeFirstLetter(offer?.lockMessage || "");
        if (["upcoming", "today"].includes(offer.category)) {
          modalTitle = "Upcoming event";
          const startTime = offer.eventDetails?.startTime || offer?.startTime;
          modalMessage = `${offer.title} is scheduled for 
                        ${format(new Date(startTime), "Pp")}.`;
        }

        return (
          <OfferCard
            margin={cardMargin}
            lock={lock}
            key={index}
            title={offer?.title || offer?.name}
            description={lock ? lockMessage : offer?.description}
            backgroundImage={offer?.image || offer?.thumbnailUri}
            onClick={() => {
              if (lock) {
                setModal({
                  title: modalTitle,
                  description: modalMessage,
                });
                return;
              }

              if (offer?.tag === "digital-skills-training") {
                history.push("/digital-skills-training");
                return;
              }
              if (offer?.tag === "skills_academy") {
                window.open(offer.url, "_blank");
                return;
              }

              if (offer.eventDetails) {
                setSelectedEvent(offer.eventDetails);
              } else {
                setData(offer);
              }
              if (offer?.eventType === "announcement") {
                setSelectedEvent(offer);
                history.push("/loyalty/announcement");
                return;
              }
              if (offer?.category === "past" || offer?.category === "live") {
                setSelectedEvent(offer);
                history.push("/loyalty/livestream");
              } else if (offer?.title === "Capture & Share") {
                history.push("/capturenshare");
              } else if (offer?.title === "Mashup & Win") {
                history.push("/mashupnwin");
              } else if (offer?.title === "Ayoba") {
                history.push("/ayoba");
              } else if (offer?.title === "Speed Shopping") {
                history.push("/speedshopping");
              } else if (offer?.offerId === "movie_mania") {
                history.push("/loyalty/moviemania");
              } else if (offer?.title === "Pulse & Chill") {
                history.push("/pulsenchill");
              } else if (offer?.offerId === "dishrack") {
                history.push("/loyalty/dishrack");
              } else if (offer?.offerId === "potbelly") {
                history.push("/loyalty/potbelly");
              } else if (offer?.tag === "pulse_trivia") {
                history.push("/trivia/trivia-category");
              } else if (offer?.isLoyalty) {
                history.push("/loyalty/loyaltydescription");
              } else if (offer?.tag === "Mashup") {
                window.location.replace(offer.url);
              } else if (offer?.tag === "vuclipgames") {
                window.location.replace(offer.url);
              } else if (offer?.tag === "Event") {
                history.push("/loyalty/eventshome");
              } else if (offer?.tag === "movie-mania-redemption") {
                history.push("/loyalty/moviemaniaredemption");
              } else if (offer?.tag === "dishrack-redemption") {
                history.push("/loyalty/dishrackredemption");
              } else if (offer?.tag === "potbelly-redemption") {
                history.push("/loyalty/potbellyredemption");
              } else if (offer?.tag === "ypyc") {
                history.push("/ypycregistration");
              } else if (
                ["upcoming"].includes(offer.category) &&
                offer.name == "MTN Pulse Just Be Series"
              ) {
                setSelectedEvent(offer);
                history.push("/just-be-series");
              } else if (offer?.tag === "jumia") {
                history.push("/black-friday");
              } else if (offer?.tag === "spin_the_wheel") {
                history.push("/spin_the_wheel");
              }
            }}
          />
        );
      })}
    </>
  );
};

export default OfferCards;
